// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'
import Image from 'components/Image/Image'
import MediaPlayer from 'components/MediaPlayer/MediaPlayer'
import { get } from 'utilities/objects'

class Columns2TextMedia extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props
		const order = get( ['settings', 'order'] )( data, 'text_image' )
		const className = `section-columns-2-text-media with-columns-order-${order}`

		const mediaData = data.media || {
			url: '',
			alt: '',
			aspect_ratio: '',
			focal_point: '',
			copy_space: '',
			width: '',
			height: '',
			thumb: '',
			srcset: '',
			type: '',

			// Video:
			id: '',
			service: '',
			thumb_url: ''
		}
		let isVideo = false

		if ( 'video' == mediaData.type || 'external_video' == mediaData.type ) {
			isVideo = true
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<div className="-item -text">
						<Editable
							element="div"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="content"
							content={ data.content }
						/>
					</div>

					<div className="-item -media-wrap">
						<div className="-media">
							<div className="editor-image-placeholder"></div>

							<Editable
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="media"
								className="-media-inner"
							>
								{ isVideo &&
									<div className="-video">
										<MediaPlayer
											key={ mediaData.id }
											id={ mediaData.id }
											service={ mediaData.service }
											url={ mediaData.url }
											thumb_url={ mediaData.thumb_url }
										/>
									</div>
								||
									<Image
										thumb={ mediaData.thumb }
										url={ mediaData.url }
										srcset={ mediaData.srcset }
										srcsetWebp={ mediaData.srcset_webp }
										sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
										alt={ mediaData.alt }
										focalPoint={ mediaData.focal_point }
										width={ mediaData.width }
										height={ mediaData.height }
										aspectRatio={ mediaData.aspect_ratio }
									/>
								}
							</Editable>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Columns2TextMedia



// WEBPACK FOOTER //
// ./components/PageSections/Columns2TextMedia.jsx